<template>
  <v-card>
    <v-card-text>
      <div class="important-text error">
        <div>
          Възникна грешка, моля свържете се с поддръжка!
          <br />
          info@articket.eu
        </div>
        <div>Error, please contact support!</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PaymentError',
  props: {
    secret: {
      type: String,
      required: true,
    },
  },
  mounted() {
    location.href = `/event/payment/error/${this.secret}`
    // gtag('event', 'conversion', { 'send_to': 'AW-756988716/RzYOCJHI84oDEKz2-ugC', 'transaction_id': this.secret });
  },
}
</script>

<style
  scoped
  lang="scss"
>
.important-text {
  text-align: center;
  font-size: 18px;
  border: 2px solid #2c80d554;
  padding: 10px;
  border-radius: 4px;
  background: #faf8ffe8;

  &.error {
    border: 2px solid #f44336;
    background: #fff8f8e8;
    font-weight: bold;
    color: white;
  }
}
</style>
